import React from 'react';

import { ComboSlotType } from 'features/menu/components/product-detail/product-customization/types';
import { ProductDetailBackArrow } from 'features/menu/components/product-detail/product-detail-flow/product-detail-back-arrow';
import { ProductDetailClose } from 'features/menu/components/product-detail/product-detail-flow/product-detail-close';
import {
  Container,
  ProductDetailFlowHeaderContainer,
  ProductTitle,
} from 'features/menu/components/product-detail/product-detail-flow/product-detail-header/styled';
import { useProductWizardContext } from 'features/menu/components/product-wizard';
import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'features/menu/components/product-wizard/use-product-wizard-flow';

import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { primitive } from 'styles/constants';

interface IProductDetailHeader {
  comboSlotType?: ComboSlotType;
  eventAttributes?: { [key: string]: string };

  /**
   * Used to be optional and had logic to figure out the title based on context, now each component is responsible for passing the title
   * You can figure out which title to pass by looking at the previous implementation here:
   * src/components/product-detail-v2/product-detail-flow/product-detail-header/use-product-detail-header.ts
   * TODO: remove this comment after all components have been updated
   */
  title: string;
}

export const ProductDetailHeader: React.FC<IProductDetailHeader> = ({ title, eventAttributes }) => {
  const { currentFlowStep, cartIdEditing, goToPreviousStep, id } = useProductWizardFlow();
  const {
    headerBackgroundColor: takeoverHeaderBg,
    fontFamily: takeoverFontFamily,
    HeaderFlair,
  } = useAppTakeoverPdp(id);

  const { setShowCloseDialog } = useProductWizardContext();

  const showCloseButton = currentFlowStep.step !== ProductWizardStep.ProductCustomization;
  const showBackArrow = currentFlowStep.step !== ProductWizardStep.ProductHome;

  const handleClose = () => {
    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes?.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_CLOSE,
      },
    });

    if (currentFlowStep.step === ProductWizardStep.ProductHome || cartIdEditing) {
      return goToPreviousStep();
    }
    setShowCloseDialog(true);
  };

  const currentStep = currentFlowStep.step;

  return (
    <ProductDetailFlowHeaderContainer
      testID="product-detail-flow-header"
      backgroundColor={
        takeoverHeaderBg ||
        (currentStep === ProductWizardStep.ProductHome ? primitive.$mayoEggWhite : primitive.$white)
      }
    >
      {HeaderFlair && <HeaderFlair />}
      <Container>
        {showBackArrow && (
          <ProductDetailBackArrow onPress={goToPreviousStep} eventAttributes={eventAttributes} />
        )}
        {showCloseButton && <ProductDetailClose onDismiss={handleClose} />}
        <ProductTitle fontFamily={takeoverFontFamily}>{title}</ProductTitle>
      </Container>
    </ProductDetailFlowHeaderContainer>
  );
};
